export const GET_EXIT_GATING_DATA = "EXIT_GATING/GET_EXIT_GATING_DATA";
export const SET_EXIT_GATING_DATA = "EXIT_GATING/SET_EXIT_GATING_DATA";
export const POST_OR_UPDATE_EXIT_GATING_DATA = "EXIT_GATING/POST_OR_UPDATE_EXIT_GATING_DATA";
export const SET_EXIT_GATING_ANALYTICS = "EXIT_GATING/SET_EXIT_GATING_ANALYTICS";
export const SET_EXIT_GATING_EDITOR_CONFIG = "EXIT_GATING/SET_EXIT_GATING_EDITOR_CONFIG";
export const RESET_EXIT_GATING_EDITOR_CONFIG = "EXIT_GATING/RESET_EXIT_GATING_EDITOR_CONFIG";
